module.exports = __webpack_public_path__ + "img/new_1.ace9c838.png";